'use client';

import { Flex, Grid, Typography } from '@coolblue-development/freddy';
import { freddyTheme } from '@coolblue-development/freddy';
import { CheckmarkCircled } from '@coolblue-development/icons';
import { useSelectedFilters } from '@features/filter/hooks/useSelectedFilters';
import { Facet } from '@features/filter/types';
import { useTranslation } from '@i18n/useTranslation';

import { ClearAllFiltersButton } from './ClearAllButton';
import { SelectedRow } from './SelectedRow';

const SelectedFilters = ({ facets }: { facets: Facet[] }) => {
  const { t } = useTranslation('webshop.filterPage.selectedFilters');
  const selectedFilters = useSelectedFilters({
    facets,
    separator: t('priceSeparator')
  });

  if (selectedFilters.length === 0) {
    return <></>;
  }

  return (
    <Grid templateColumns='1fr' mt={400} gap={200}>
      <Flex justifyContent='space-between' wrap='wrap' alignItems='center'>
        <Flex alignItems='center'>
          <CheckmarkCircled color={freddyTheme.color.icon.sentimentPositiveContrast} />

          <Typography mb={0} ml={{ sm: 100, lg: 200 }} fontWeight={700} fontSize='xl'>
            {t('title')}
          </Typography>
        </Flex>

        <ClearAllFiltersButton />
      </Flex>

      {selectedFilters.map(filter => (
        <SelectedRow
          key={filter.name}
          displayValues={{
            filterName: filter.selectedFilters?.displayName ?? '',
            filterValue: filter.selectedFilters?.values ?? []
          }}
          filterIdentifier={filter.name}
        />
      ))}
    </Grid>
  );
};

export default SelectedFilters;
